__turbopack_context__.v({
  "action": "WalletItems-module__5sOuCW__action",
  "currentItemsHeader": "WalletItems-module__5sOuCW__currentItemsHeader",
  "root": "WalletItems-module__5sOuCW__root",
  "soldItemsColumn": "WalletItems-module__5sOuCW__soldItemsColumn",
  "soldItemsHeader": "WalletItems-module__5sOuCW__soldItemsHeader",
  "table": "WalletItems-module__5sOuCW__table",
});
